import { render } from "./AppLabelPlaces.vue?vue&type=template&id=584d2423&scoped=true&ts=true"
import script from "./AppLabelPlaces.vue?vue&type=script&lang=ts"
export * from "./AppLabelPlaces.vue?vue&type=script&lang=ts"

import "./AppLabelPlaces.vue?vue&type=style&index=0&id=584d2423&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584d2423"]])

export default __exports__